import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'BroadcastingPage.title',
    defaultMessage: 'Broadcasting your withdrawal transactions...',
    description: 'Title for broadcasting page',
  },
  description: {
    id: 'BroadcastingPage.description',
    defaultMessage: `Your withdrawal transactions were submitted. It may take a few seconds to be confirmed.`,
    description: 'Description text prompting user to broadcast their transaction',
  },
  noTransactionsErrorToast: {
    id: 'ReviewPage.noTransactionsErrorToast',
    defaultMessage: 'No transactions to broadcast, please re-enter your seed phrase.',
    description:
      'Message shown when the user needs to start over because there are no transactions',
  },
});
